import { Injectable } from '@angular/core'
import { filter } from 'rxjs/operators'
import { CustomerChooseComponent } from 'src/app/shared/components/dialog/components/customer-choose/customer-choose.component'
import { CSModel } from 'src/app/shared/components/dialog/components/customer-choose/model/cs.model'
import { CustomerChooseService } from 'src/app/shared/components/dialog/components/customer-choose/service/customer-choose.service'
import { DialogService } from 'src/app/shared/components/dialog/service/dialog.service'
import { StorageService } from '../../storage/storage.service'
import { Profile } from '../model/profile'
import { ProfileManagementService } from '../profile-management/profile-management.service'
import { HierarchyManagementService } from '../hierarchy-management/hierarchy-management.service'
import { Router } from '@angular/router'

@Injectable({
	providedIn: 'root',
})
export class CsManagementService {
	constructor(
		private dialogService: DialogService,
		private storageService: StorageService,
		private profileManagementService: ProfileManagementService,
		private hierarchyManagementService: HierarchyManagementService,
		private customerChooseService: CustomerChooseService,
		private router: Router
	) {}

	openDialogForChooseCustomerToManage(isMobile, closable = false): any {
		return this.dialogService.onOpenDialogResponsive(isMobile, CustomerChooseComponent, {
			closable,
		})
	}
	setCustomerService(isMobile) {
		this.openDialogForChooseCustomerToManage(isMobile).subscribe((profileSelected) => {
			sessionStorage.setItem('cs_externalId', profileSelected.externalId)
			this.customerChooseService
				.getContactProfileByExternalId(profileSelected.externalId)
				.pipe(filter((res: any) => !!res?.profiles[0]))
				.subscribe((res: any) => {
          this.router.navigate(['/welcome'])
					const profiles = res.profiles
					this.hierarchyManagementService.clearHierarchy()
					this.setProfilesInStore(profiles)
					if (this.conditionForChooseProfile(profiles)) {
						this.profileManagementService
							.openDialogForChooseProfile(isMobile, profiles)
							.subscribe((profileSelected) => {
								this.profileManagementService.setAndCheckProfile(profileSelected)
							})
					} else {
						this.profileManagementService.setOnlyProfileAvailable(profiles)
						this.profileManagementService.setAndCheckProfile(profiles[0], false, true)
					}
				})
		})
	}

	setProfilesInStore(profiles) {
		this.profileManagementService.setProfilesInStore(profiles)
	}

	conditionForChooseProfile(profiles): boolean {
		return profiles.length > 1 || profiles[0].roles.length > 1
	}

	setCustomerServiceInStore(csSelected: CSModel): void {
		this.storageService.setSessionStorage('customerService', JSON.stringify(csSelected))
	}

	setProfileChooseByCSInStore(cs_externalId) {
		this.storageService.setSessionStorage('cs_externalId', JSON.stringify(cs_externalId))
	}

	getProfileChooseByCSInStore(): any {
		return JSON.parse(this.storageService.getSessionStorage('cs_externalId'))
	}

	getCustomerServiceByStore(): any {
		return JSON.parse(this.storageService.getSessionStorage('customerService'))
	}
}
